export default {
  MuiTableHead: {
    root: {
      backgroundColor: '#212121',
    },
  },
  MuiTableCell: {
    root: {
      verticalAlign: 'top',
    },
    body: {},
    head: {
      color: '#ffffff',
      verticalAlign: 'middle',
    },
  },
};



// WEBPACK FOOTER //
// ./src/layouts/ThemeProvider/overrides/Table.js